@if (show) {
<div class="test-overlay" (click)="onOverlayClick($event)">
  <div class="test-panel">
    <div class="panel-header">
      <div class="header-title">
        <fa-icon [icon]="icons.faBolt"></fa-icon>
        <div class="header-texts">
          <span class="title">{{ 'PROCESSINGS.TEST_MODAL.TITLE' | translate }}</span>
          @if (operation?.description) {
            <span class="subtitle">{{ operation?.description }}</span>
          }
        </div>
      </div>
      <button type="button" class="close-btn" (click)="onClose()">
        <fa-icon [icon]="icons.faTimes"></fa-icon>
      </button>
    </div>

    <div class="panel-body">
      @if (isAi) {
        <div class="llm-field">
          <label>{{ 'PROCESSINGS.FIELDS.TEST_MODEL' | translate }}</label>
          <ng-select
            [items]="llmConfigs"
            bindLabel="display_label"
            bindValue="id"
            [ngModel]="llmConfigId"
            (ngModelChange)="onLlmChange($event)"
            [clearable]="false"
            [searchable]="true"
            appendTo="body"
            [placeholder]="'SETTINGS.PREFERENCES.DELFOS_LLM' | translate">
          </ng-select>
        </div>
      }

      <div class="result-block">
        <span class="result-label">{{ 'PROCESSINGS.TEST_MODAL.RESULT' | translate }}</span>

        @if (loading) {
          <div class="result-loading">
            <fa-icon [icon]="icons.faSpinner" animation="spin"></fa-icon>
          </div>
        } @else if (error) {
          <pre class="result-pre result-pre--error">{{ error }}</pre>
        } @else if (output !== undefined) {
          <pre class="result-pre">{{ output }}</pre>
        } @else {
          <div class="result-empty">—</div>
        }
      </div>
    </div>

    <div class="panel-footer">
      <button type="button" class="retry-btn" [disabled]="loading" (click)="run()">
        @if (loading) {
          <fa-icon [icon]="icons.faSpinner" animation="spin"></fa-icon>
        } @else {
          <fa-icon [icon]="icons.faBolt"></fa-icon>
        }
        <span>{{ 'PROCESSINGS.TEST_MODAL.RETRY' | translate }}</span>
      </button>
    </div>
  </div>
</div>
}
